<script lang="ts">
  // libs
  import { onMount } from "svelte";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";

  // components
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";

  // services
  import * as PaymentsService from "@distributor/services/payments_service";

  let dwollaBalance: number | null = null;

  onMount(() => {
    (async () => {
      const res = await PaymentsService.getDwollaBalance();

      if (res) dwollaBalance = res.value;
    })();
  });

</script>

<div class="fizz-tooltip-container">
  <button class="fizz-tooltip-trigger fizz-flex-row-8">
    <div class="fizz-flex-row-4">
      <p>Dwolla Account Balance:</p>
      {#if dwollaBalance}
        <strong>
          <FormatMoney input={dwollaBalance} formatType={"5"} />
        </strong>
      {:else}
        <Skeleton animate height={24} width={100} />
      {/if}
    </div>
    <svg class="fizz-icon-16">
      <Icon type={"Info"} extraClassNames={"fizz-icon-16"} />
    </svg>
  </button>
  <div class="fizz-tooltip fizz-tooltip-right" role="tooltip">
    This balance reflects the total amount for all invoices that were settled today. The total
    balance will be deposited to your bank account at the beginning of the next day.
  </div>
</div>
